import { appsUrl } from "../config/urls";
import { JWTAuth } from "jwt-usu";
import Cookies from "js-cookie";

const callbackLogout = () => {
  JWTAuth.recv({
    ssotok: Cookies.get("ssotok"),
    secured: true,
  });
};

const signOut = (redir = "") => {
  const logoutLink = JWTAuth.makeLink({
    type: "logout",
    baseUrl: "https://sso.usu.ac.id/auth/logout",
    redir: appsUrl + redir,
    callback: callbackLogout,
  });
  window.location = logoutLink;
};

export default signOut;
